import { render, staticRenderFns } from "./readingWriting.vue?vue&type=template&id=9a3600d8&"
import script from "./readingWriting.vue?vue&type=script&lang=js&"
export * from "./readingWriting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports